"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceReceipt = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InvoiceReceipt = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    receipt_invoice: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    over_weight_limit_by: typebox_1.Type.String(),
    invoice_number: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
    payment_link: typebox_1.Type.String(),
});
//# sourceMappingURL=invoice-receipt.js.map